/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    form?: unknown;
  };
}

import Component from "@glimmer/component";
import { t } from "ember-intl";

export default class MedicalHistoryFormRenalPathologyComponent extends Component<Signature> {
  t = t;

  nephropaties = [
    "nephropathy_undefined",
    "nephropathy_diabetic",
    "nephroangiosclerose",
    "berger_disease",
    "hyalinosis",
    "glomerulonephritis",
    "polycystic_kidney_disease",
    "uropathies",
    "lupus",
    "vasculitis",
    "pyelonephritis"
  ];
}
